document.addEventListener('DOMContentLoaded', (event) => {
  Sceon.StatusMessages = {};
  Sceon.StatusMessages.url = 'status-messages';

  Sceon.StatusMessages.Load = function (page = 0) {
    if (page > 0) {
      if (page === undefined || page < 1) {
        page = 1;
      }
      let sm = new Sceon.Overlay($('body'), {
        loader: '/img/loader-tiny.gif',
        offset: { bottom: 0, top: 0 },
      });
      sm.enable();

      location.href = Sceon.StatusMessages.url + '?page=' + page;
    }
  };

  $('.status-messages-filter select').on('change', function () {
    const val = $(this).val();
    let sm = new Sceon.Overlay($('body'), {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0 },
    });
    sm.enable();

    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', 1);
    if (val && val !== 'null') {
      searchParams.set('area_id', val);
    } else {
      searchParams.delete('area_id');
    }
    window.location.search = searchParams.toString();
  });
});
